module.exports = __webpack_public_path__ + "static/assets/680b3ff6a51d8fc77fbaf8695c8de929.svg";